<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'


import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import AddEdit from "./StrPerfTablo/AddEdit.vue";
import AddEditAlt from "./StrPerfTablolarDetay/AddEdit.vue";
import FormulOlustur from "./StrPerfTablolarDetay/FormulOlustur.vue";


import StrPerfTablo from "@/models/StrPerfTablo";
import StrPerfTablolarDetay from "@/models/StrPerfTablolarDetay";
import StrPerfTablolarDetayParametre from "./StrPerfTablolarDetayParametre/IndexModal.vue";

import HedefKartlariDetay from "./StrHedefKartlariDetay.vue";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [Api, Sabit, StrPerfTablo, StrPerfTablolarDetay],

  page: {
    title: "Hedef Kartları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Drawer,
    PageHeader,
    AddEdit,
    AddEditAlt,
    FormulOlustur,
    HedefKartlariDetay,
    StrPerfTablolarDetayParametre,
        Treeselect,
  },
  data() {
    return {
      title: this.$t("StrPerfTablo.Title"),
      tablo1_visible: false,
      items: [
        {
          text: this.$t("StrPerfTablo.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrPerfTablo.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrPerfTablo.Title"),
          active: true,
        },
      ],

      islem: "",
      TableData: [],
      ComboboxStrGostergeler: [],
       gostergeler: [],
       secilen_gostergeler: null,
      Gosterge: null,
      StrPerfDonem: [],
      DataUpdate: null,
      DataUpdateAlt: null,
      TabloDonemi:null,
      FilitrelemePenceresi: false,
      Guncelleme: 0,
      siralama:"&Asc=SiraNo",

      Filter: {
        Adi: "",
        DonemId: "",
        GostergeId: null,
      },

      DefaultPage: 1,

      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },

      AddEdit: "",
      AddEditAlt: "",
    };
  },

  methods: {
    Get() {
       
      this.Guncelleme = this.Guncelleme+1;
      let Filter ="";

      if(this.Filter.DonemId!=null && this.Filter.DonemId!=""){
        Filter=Filter+"&DonemId="+this.Filter.DonemId;
      }

       if(this.Filter.GostergeId!=null && this.Filter.GostergeId!=""){
        Filter=Filter+"&GostergeId="+this.Filter.GostergeId;
      }

      if(this.Filter.Adi!=null && this.Filter.Adi!=""){
        Filter=Filter+"&Adi="+this.Filter.Adi;
      }

      if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }

      this.ActionsFilterGet({ Service: "StrPerfTablo", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });

     //this.liste_yukle();

    },

    loadOptions({ action,  callback }) {
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

          const options = this.gostergeler;

          callback(null, options)
        })
      }
    },
    

    liste_yukle(veri){
      let Page = {
        PageNumber: "1",
        PageSize: "100",
      };

      if (veri.length>=1){

      this.gostergeler=[];
      let Filter="&Asc=Gostergesi&Gostergesi="+veri;

      this.ActionsFilterGet({ Service: "StrPerfTablolarDetay", Page: Page, Filter:Filter }).then((res) => {
        this.ComboboxStrGostergeler = res.Data;

          for(var i=0; i<this.ComboboxStrGostergeler.length;i++){

            this.gostergeler.push({ id: this.ComboboxStrGostergeler[i].Id, label: this.ComboboxStrGostergeler[i].Gostergesi })
             
          }

      });

    }

    },

    Gostergem(gosterge_id) {
      this.Gosterge = gosterge_id;
    },

    UpdateStrAlt(Data) {
      this.DataUpdateAlt = Data;
    },

    islemAlt(islem) {
      this.AddEditAlt = islem;
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    Tablo_Donemi(Donem){
      this.TabloDonemi=Donem;
    }
  },

  created() {
    let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };


          let sorgu = "&Tip=1561";
          let Tip=[];
            
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
              console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 

                        Tip.push(res.Data[i].Id);       

                    } 
                   
                }

                let altsorgu="&UstIdDoluMu=false&Approval=true";

                let tipler="";

                for (var s=0; s<Tip.length; s++){

                    tipler=tipler+"&TipId="+Tip[s];

                }

                altsorgu=altsorgu+tipler;

             

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                    this.StrPerfDonem.push({ Id: res.Data[i].Id, Value: res.Data[i].Aciklama });
                  
                }
              });
         
            });
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
    
                    <input @input="Filter.Adi.length >= 3 || Filter.Adi.length == 0 ? Get() : ''" 
                    v-model="Filter.Adi" type="text" class="form-control" placeholder="Arama..." />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2"
                   @click="rightDrawer(),Filter.GostergeId=null">
                   <i class="mdi mdi-text-search me-1"></i> {{ this.$t("StrPerfTablo.Page.Filtreleme") }}</button>

                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrPerfTablo @click="(DataUpdate = StrPerfTabloData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i> {{ this.$t("StrPerfTablo.Page.YeniKayitEkle") }}</button>
                </div>
              </div>
            </div>

            <!--ANCHOR --Tablo Alanı Başlangıcı -->

            <div class="table-responsive">
        
               

              <table class="table table-striped table-bordered mb-0">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ this.$t("StrPerfTablo.Table.SiraNo") }}
                    <i style="margin-left:10px" v-if="siralama!='&Asc=SiraNo'" @click="siralama='&Asc=SiraNo', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=SiraNo'" @click="siralama='&Desc=SiraNo', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                    <th scope="col">{{ this.$t("StrPerfTablo.Table.DonemId") }}
                     <i style="margin-left:10px" v-if="siralama!='&Asc=DonemId'" @click="siralama='&Asc=DonemId', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=DonemId'" @click="siralama='&Desc=DonemId', Get()" class="bx bx-sort-z-a  fa-xl"></i>               
                    </th>
                    <th scope="col">{{ this.$t("StrPerfTablo.Table.Adi") }}
                     <i style="margin-left:10px" v-if="siralama!='&Asc=Adi'" @click="siralama='&Asc=Adi', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Adi'" @click="siralama='&Desc=Adi', Get()" class="bx bx-sort-z-a  fa-xl"></i>

                    </th>
                    <th scope="col">{{ this.$t("StrPerfTablo.Table.AmacId") }}
                    <i style="margin-left:10px" v-if="siralama!='&Asc=AmacId'" @click="siralama='&Asc=AmacId', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=AmacId'" @click="siralama='&Desc=AmacId', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>
                    <th scope="col">{{ this.$t("StrPerfTablo.Table.Hedefi") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=Hedefi'" @click="siralama='&Asc=Hedefi', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Hedefi'" @click="siralama='&Desc=Hedefi', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    </th>

                    <th scope="col">{{ this.$t("StrPerfTablo.Table.PerformansHedefi") }}</th>
              
                    <th style="width: 85px; text-align: center; vertical-align: middle;">
                    {{ this.$t("StrPerfTablo.Table.Aktif") }}
                     <i style="margin-left:10px" v-if="siralama!='&Asc=Aktif'" @click="siralama='&Asc=Aktif', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Aktif'" @click="siralama='&Desc=Aktif', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                    
                    </th>
                    <th style="width: 85px; text-align: center; vertical-align: middle;">{{ this.$t("StrPerfTablo.Table.Islem") }}</th>
                  </tr>
                </thead>
                <tbody v-for="Data in TableData" :key="Data.Id">
                  <tr>
                    <th scope="row" class="custom-accordion">
                      <a class="text-body fw-medium py-1 d-flex align-items-center" data-toggle="collapse" v-b-toggle="'CollapseAltTablo' + Data.Id" role="button" aria-expanded="false" aria-controls="categories-collapse">
                        <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                      </a>
                    </th>
                    <td>{{ Data.SiraNo }}</td>
                    <td>{{ Data.DonemAciklama }}</td>
                    <td>{{ Data.Adi }}</td>
                    <td>{{ Data.StratejikAciklama }}</td>
                    <td>{{ Data.Hedefi }}</td>
                    <td>{{ Data.PerformansHedefi }}</td>
                    <!-- <td>{{ Data.Notu }}</td> -->
                    <td style="width: 85px; text-align: center; vertical-align: middle;">
                      
                        <i v-if="Data.Aktif" class="fas fas fa-check"></i>
                        <i v-if="!Data.Aktif" class="fas fas fa-times"></i>
                      
                    </td>
                    <td style="width: 85px; text-align: center; vertical-align: middle;">
                 

                      <b-button-group>
      
                          <b-button variant="primary" v-b-modal.StrPerfTablolarDetay @click="(DataUpdateAlt = StrPerfTablolarDetayData), 
                          (AddEditAlt = 'Add'), (StrPerfTablolarDetayData.TabloId = Data.Id),(TabloDonemi=Data.DonemId)">
                            <i class="fas fa-plus"></i></b-button>
                          <b-button variant="success" v-b-modal.StrPerfTablo @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                          <b-button variant="danger" @click="Delete('StrPerfTablo', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                      </b-button-group>



                    </td>
                  </tr>
                  <tr>
                    <td colspan="10">
                      <b-collapse class="collapse show" :id="'CollapseAltTablo' + Data.Id">

                        <HedefKartlariDetay :Guncelle="Guncelleme" :DonemId="Data.DonemId" 
                        :TanimId="Data.Id" @DataUpdateAlt="UpdateStrAlt($event)" 
                        @AddEditAlt="islemAlt($event)" @Gosterge="Gostergem($event)" 
                        @TabloDonemi="Tablo_Donemi($event)"/>
                      
                      </b-collapse>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />

              <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
            </div>
          </div>
        </div>
      </div>

      <!--ANCHOR  --ÜST FORM ALANI ---------------------->

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get()" />



      <!--ANCHOR  --ALT FORM ALANI ---------------------->

      <AddEditAlt :Id="DataUpdateAlt" :DonemId="TabloDonemi"  :AddEdit="AddEditAlt" @TableUpdate="Get()" />

        <!--ANCHOR  --FORMÜL OLUŞTURMA EKRANI ---------------------->

      <FormulOlustur :Id="DataUpdateAlt" :DonemId="TabloDonemi" />



      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrPerfTablo.Filtreleme.Title") }}
            </h5>
          </div>
          <div >
            {{ $t("StrPerfTablo.Filtreleme.Content") }}
            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrPerfTablo.Filtreleme.DonemId") }}</label>
              <select style="width:750px" v-model="Filter.DonemId" class="form-select" type="text">
                <option value="">{{ $t("StrPerfTablo.Filtreleme.DonemId") }}</option>
                <option v-for="DonemVerileri in StrPerfDonem" :key="DonemVerileri.Id" :value="DonemVerileri.Id">
                  {{ DonemVerileri.Value }}
                </option>
              </select>
            </div>

             <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrPerfTablo.Filtreleme.TabloAdi") }}</label>
              <b-form-input  style="width:750px" for="text" v-model="Filter.Adi" value=""></b-form-input>
            </div>
          <!--
            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrPerfTablo.Filtreleme.Gostergesi") }}</label>
              <select style="width:400px" v-model="Filter.GostergeId" class="form-select" type="text">
                <option value="">Gösterge Seçiniz</option>
                <option v-for="Gostergeler in ComboboxStrGostergeler" :key="Gostergeler.Id" :value="Gostergeler.Id">
                  {{ Gostergeler.Gostergesi }}
                </option>
              </select>
            </div>
            -->

              <b-form-group class="mb-3" id="example text"  label="Göstergeler" label-for="text">
        
                <treeselect 
                style="width:750px"
                @search-change="liste_yukle($event)"
                :async="true"
                :load-options="loadOptions"
                :multiple="false" 
                searchPromptText="Aramak için yazın..."
                placeholder="Seçiniz..." 
                v-model="Filter.GostergeId" 
                          
                 />
                <treeselect-value :value="Filter.GostergeId" />
              </b-form-group>
             

             </div>
               <b-button @click="Get(),rightDrawer()" class="btn btn-primary" variant="primary">{{ $t("StrPerfTablo.Filtreleme.Button") }}</b-button>
       
        </div>
      </Drawer>

      <b-modal id="StrPerfTablolarDetayParametre" size="lg" :title="$t('StrPerfTablolarDetayParametre.Title')" title-class="font-18" hide-footer>
        <StrPerfTablolarDetayParametre :TanimId="Gosterge" />
      </b-modal>

    </Layout>
  </Loader>
</template>
